import { render, staticRenderFns } from "./RegisterVacationDrawer.vue?vue&type=template&id=2b11b34c&scoped=true&"
import script from "./RegisterVacationDrawer.vue?vue&type=script&lang=js&"
export * from "./RegisterVacationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVacationDrawer.vue?vue&type=style&index=0&id=2b11b34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11b34c",
  null
  
)

export default component.exports